
import { Component, Vue } from "vue-property-decorator";

import { gsap } from "gsap";

export const IMG_WIDTH = 1200;
export const IMG_HEIGHT = 780;

@Component({
  components: {
  },
})

export default class App extends Vue {  
  created() {
    window.addEventListener("resize", this.sizeAll);
    window.addEventListener("orientationchange", this.sizeAll);
  }
  destroyed() {
    window.removeEventListener("resize", this.sizeAll);
    window.removeEventListener("orientationchange", this.sizeAll);
  }

  mounted() {
    gsap.set("#app-main", { transformOrigin: "top left" });
    this.sizeAll();
  }

  sizeAll() {
    // your code for handling resize...
    // To resize window: https://stackoverflow.com/questions/18750769/scale-div-with-its-content-to-fit-window

    let w = document.documentElement.clientWidth;
    let h = document.documentElement.clientHeight;

    let ratioImage = IMG_WIDTH / IMG_HEIGHT;
    let ratioClient = w / h;

    // console.log("document.documentElement.clientWidth/Height ", w, h);
    // console.log("IMG_WIDTH/HEIGHT: ", IMG_WIDTH, IMG_HEIGHT);
    // console.log("ratioImage/Client: ", ratioImage, ratioClient);

    // let s_w = (w - 50) / IMG_WIDTH;
    // let s_h = (h - 50) / IMG_HEIGHT;
    let s_w = (w) / IMG_WIDTH;
    let s_h = (h) / IMG_HEIGHT;

    let s = ratioClient > ratioImage ? s_h : s_w;
    // console.log("A scale: ", s_w, s_h, s);
    if (s > 2.5) s = 2.5;
    gsap.set("#app-main", { scale: s });

    let appMain = document.getElementById("app-main");
    if (appMain === null) return;
    let ww = appMain.getBoundingClientRect().width;
    // console.log("w: ", w, " - appMain.getBoundingRect.width: ", ww);
    let wh = appMain.getBoundingClientRect().height;
    // console.log("h", h, " - appMain.getBoundingRect.height: ", wh);

    // if (w > ww) 
      gsap.set("#app-main", { x: (w - ww) / 2 });
    // if (h > wh) 
      gsap.set("#app-main", { y: (h - wh) / 2 });
  }

}
